//axios 工具函数
import store from "@/store";
import axios from "axios";

//封装 默认地址&超时时间
const instance = axios.create({
  //提取环境文件中的 服务器地址
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 30000,
  // headers: {
  //   "ngrok-skip-browser-warning": 69420,
  // },
});
//封装请求拦截器 携带统一参数
instance.interceptors.request.use(
  (config) => {
    //携带token
    config.headers.authorization = localStorage.getItem("token");
    return config;
  },
  (err) => {
    this.$toast.clear();
    return Promise.reject(err);
  }
);
//封装响应拦截器 处理状态码
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    return Promise.reject(err);
  }
);

//导出封装好的axios 实例
export default instance;
